<template>
  <div>
    <h2>送信が完了しました</h2>

    <el-row style="display:flex; justify-content:center;">
      <el-col  :span="15">
        <value-list></value-list>
      </el-col>
    </el-row>
    <div style="display:flex; justify-content:center;">
      <v-btn @click="homeBackClick">ホームへ</v-btn>
    </div>

  </div>
</template>

<script>
import store from "../../store";
import ValueList from "./ValueList";

export default {
  components: {
    ValueList
  },
  created: function () {
    this.$store.commit("contact/stepActive", 2);
  },
  beforeRouteEnter(to, from, next) {
    //console.log("store", store);
    //値が存在しないときはフォーム画面に戻す
    if (store.getters["contact/isEmpty"]) {
      next("/contact");
    }
    next();
  },
  methods: {
    /**
     * データをリセットしてメールフォームに戻る
     */
    homeBackClick() {
      this.$store.dispatch("contact/clearContactValues", this.ruleForm);
      this.$router.push("/");
    }
  }
};
</script>

